/**
 * Cloud Lifestyle — shared homepage behavior.
 * Ported from reference/provided-design.html's inline <script> (announcement
 * rotator, reveal-on-scroll, sticky buy-bar visibility, bundle selection,
 * toast, single-open FAQ accordion). Loaded once, site-wide, from
 * layout/theme.liquid rather than duplicated per-section.
 *
 * All the elements this file looks for (#barMsg, .reveal, #buybar, .bundle,
 * .faq details, …) only exist on the homepage sections that render them, so
 * every block below is guarded — this script is safe to load on every page,
 * not just the homepage.
 */
(function () {
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------------- announcement rotator ---------------- */
  var msgs = [
    'Free worldwide shipping on orders over $50',
    '30-day money-back guarantee on every pair',
    'Launch offer: bundles up to 37% off'
  ];
  var icons = ['#i-truck', '#i-shield', '#i-sun'];
  var bi = 0;
  var barMsg = document.getElementById('barMsg');
  var barText = document.getElementById('barText');
  if (!reduced && barMsg && barText) {
    setInterval(function () {
      barMsg.classList.add('fade');
      setTimeout(function () {
        bi = (bi + 1) % msgs.length;
        barText.textContent = msgs[bi];
        var use = barMsg.querySelector('use');
        if (use) use.setAttribute('href', icons[bi]);
        barMsg.classList.remove('fade');
      }, 450);
    }, 4200);
  }

  /* ---------------- reveal on scroll ---------------- */
  var revealEls = document.querySelectorAll('.reveal');
  if (revealEls.length) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.classList.add('in');
          io.unobserve(e.target);
        }
      });
    }, { threshold: .14 });
    revealEls.forEach(function (el) { io.observe(el); });
  }

  /* ---------------- sticky buy bar after hero ---------------- */
  var buybar = document.getElementById('buybar');
  var hero = document.querySelector('.hero');
  var offer = document.getElementById('offer');
  if (buybar && hero && offer) {
    var onScroll = function () {
      var past = window.scrollY > hero.offsetHeight - 80;
      var r = offer.getBoundingClientRect();
      var offerVisible = r.top < window.innerHeight && r.bottom > 120;
      buybar.classList.toggle('show', past && !offerVisible);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* ---------------- toast ---------------- */
  var toast = document.getElementById('toast');
  var tt;
  function showToast(text) {
    if (!toast) return;
    toast.textContent = text;
    toast.classList.add('show');
    clearTimeout(tt);
    tt = setTimeout(function () { toast.classList.remove('show'); }, 3600);
  }
  // Exposed for any future real add-to-cart confirmation flow — not wired to
  // a demo/placeholder message on real buttons, see sections/offer.liquid.
  window.CloudLifestyleToast = showToast;

  /* ---------------- reveal safety net ----------------
     .js .reveal starts at opacity 0. If the IntersectionObserver never runs
     (script error, unsupported, observer detached) the page would stay blank,
     so force everything visible after a grace period. */
  setTimeout(function () {
    document.querySelectorAll('.reveal:not(.in)').forEach(function (el) {
      var r = el.getBoundingClientRect();
      if (r.top < window.innerHeight * 1.5) el.classList.add('in');
    });
  }, 2500);

  /* ---------------- add to cart ----------------
     The bundle form posts to /cart/add, which navigates away with no
     confirmation. Intercept it, post to /cart/add.js instead, show the toast
     that already exists, and refresh the header count. The plain POST stays
     as the no-JS fallback because we only preventDefault once we know fetch
     is going to run. */
  function refreshCartCount() {
    return fetch(window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + 'cart.js' : '/cart.js',
                 { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll('.cart-count, [data-cart-count]').forEach(function (el) {
          el.textContent = cart.item_count;
        });
        return cart;
      })
      .catch(function () { /* count is cosmetic; never block on it */ });
  }

  document.querySelectorAll('form[action$="/cart/add"]').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      if (!window.fetch || !window.FormData) return;   // let the browser post it
      e.preventDefault();
      var btn = form.querySelector('[type=submit]');
      var label = btn ? btn.textContent : '';
      if (btn) { btn.disabled = true; btn.textContent = 'Adding…'; }

      fetch('/cart/add.js', { method: 'POST', body: new FormData(form) })
        .then(function (r) { return r.json().then(function (b) { return { ok: r.ok, body: b }; }); })
        .then(function (res) {
          if (!res.ok) throw new Error(res.body.description || res.body.message || 'Could not add to cart');
          // straight to the cart page once the add succeeds
          window.location.href = (window.Shopify && window.Shopify.routes
            ? window.Shopify.routes.root : '/') + 'cart';
          return null;
        })
        .catch(function (err) { showToast(err.message || 'Could not add to cart'); })
        .then(function () {
          if (btn) { btn.disabled = false; btn.textContent = label; }
        });
    });
  });

  /* ---------------- bundle card selection ----------------
     Removed. The cards are <label>s wrapping radios; CSS styles the selected
     state from :has(.bundle-radio:checked). The old handler also added a
     .selected class styled a different colour, so two systems were fighting
     and only cascade order decided the winner. */

  /* ---------------- cart page: live quantity updates ----------------
     Quantity intent is held in JS state, not read back out of the input.
     Reading the DOM meant a fast second click computed from a value the first
     request had not yet confirmed, so clicks were lost; and clearing the field
     produced Math.max(1, NaN) === NaN, which sent quantity:null, failed, and
     bounced the page. Each line now debounces to one request per settled
     value. */
  var cartRoot = document.querySelector('[data-cart-root]');
  if (cartRoot) {
    var manual = cartRoot.querySelector('[data-manual-update]');
    if (manual) manual.hidden = true;

    var threshold = parseInt(cartRoot.dataset.threshold, 10) || 0;
    var desired = {};
    var timers = {};
    var inflight = 0;

    cartRoot.querySelectorAll('[data-line]').forEach(function (row) {
      var input = row.querySelector('[data-qty]');
      desired[row.dataset.line] = parseInt(input && input.value, 10) || 1;
    });

    function money(cents, currency) {
      try {
        return new Intl.NumberFormat(document.documentElement.lang || 'en', {
          style: 'currency', currency: currency || 'USD'
        }).format(cents / 100);
      } catch (e) { return '$' + (cents / 100).toFixed(2); }
    }

    function render(cart) {
      if (!cart || !cart.items) return;
      if (!cart.item_count) { window.location.reload(); return; }

      cart.items.forEach(function (item, i) {
        var line = String(i + 1);
        var row = cartRoot.querySelector('[data-line="' + line + '"]');
        if (!row) return;
        var t = row.querySelector('[data-line-total]');
        if (t) t.textContent = money(item.final_line_price, cart.currency);
        var q = row.querySelector('[data-qty]');
        if (q && document.activeElement !== q && !timers[line] && !inflight) {
          q.value = item.quantity;
          desired[line] = item.quantity;
        }
      });

      var sub = cartRoot.querySelector('[data-subtotal]');
      if (sub) sub.textContent = money(cart.items_subtotal_price, cart.currency);
      var tot = cartRoot.querySelector('[data-total]');
      if (tot) tot.textContent = money(cart.total_price, cart.currency);

      // bundle discount grows and shrinks with quantity, so it has to move
      // with the tier - and appear at all if the cart started undiscounted
      var discRow = cartRoot.querySelector('[data-discount-row]');
      var disc = cartRoot.querySelector('[data-discount]');
      if (discRow && disc) {
        var amount = cart.total_discount || 0;
        disc.textContent = '−' + money(amount, cart.currency);
        discRow.hidden = amount <= 0;
      }

      var qualifies = threshold > 0 && cart.items_subtotal_price >= threshold;
      var shipLabel = cartRoot.querySelector('[data-ship-label]');
      if (shipLabel) shipLabel.textContent = qualifies ? 'Free' : 'Calculated at checkout';

      var ship = cartRoot.querySelector('[data-ship]');
      if (ship && threshold > 0) {
        ship.classList.toggle('is-free', qualifies);
        var pct = Math.min(100, Math.round(cart.items_subtotal_price * 100 / threshold));
        var fill = ship.querySelector('[data-ship-fill]');
        if (fill) fill.style.width = pct + '%';
        var msg = ship.querySelector('[data-ship-msg]');
        if (msg) {
          msg.textContent = qualifies
            ? 'Free shipping unlocked.'
            : money(threshold - cart.items_subtotal_price, cart.currency) + ' away from free shipping.';
        }
      }

      document.querySelectorAll('.cart-count, [data-cart-count]').forEach(function (el) {
        el.textContent = cart.item_count + (cart.item_count === 1 ? ' item' : ' items');
      });
    }

    /* change.js returns a total_price that INCLUDES the shipping estimate,
       while /cart.js and Liquid's cart.total_price do not. Always re-read
       /cart.js so the figures match what a reload would show. */
    function commit(line) {
      clearTimeout(timers[line]);
      delete timers[line];
      var qty = desired[line];
      if (typeof qty !== 'number' || !isFinite(qty) || qty < 0) return;
      inflight++;
      cartRoot.classList.add('is-busy');
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ line: Number(line), quantity: qty })
      })
        .then(function (r) {
          if (!r.ok) throw new Error('change failed');
          return fetch('/cart.js', { headers: { Accept: 'application/json' } });
        })
        .then(function (r) { return r.json(); })
        .then(render)
        .catch(function () { window.location.reload(); })
        .then(function () {
          inflight = Math.max(0, inflight - 1);
          if (!inflight) cartRoot.classList.remove('is-busy');
        });
    }

    function schedule(line, wait) {
      clearTimeout(timers[line]);
      timers[line] = setTimeout(function () { commit(line); }, wait);
    }

    function setQty(row, qty, wait) {
      var line = row.dataset.line;
      qty = Math.max(1, qty);
      desired[line] = qty;
      var input = row.querySelector('[data-qty]');
      if (input) input.value = qty;
      schedule(line, wait);
    }

    cartRoot.addEventListener('click', function (e) {
      var step = e.target.closest('[data-step]');
      if (step) {
        e.preventDefault();
        var row = step.closest('[data-line]');
        var base = desired[row.dataset.line];
        setQty(row, base + parseInt(step.dataset.step, 10), 400);
        return;
      }
      var rm = e.target.closest('[data-remove]');
      if (rm) {
        e.preventDefault();
        var r2 = rm.closest('[data-line]');
        desired[r2.dataset.line] = 0;
        commit(r2.dataset.line);
      }
    });

    cartRoot.addEventListener('input', function (e) {
      var q = e.target.closest('[data-qty]');
      if (!q) return;
      var row = q.closest('[data-line]');
      var raw = q.value.trim();
      if (raw === '') { clearTimeout(timers[row.dataset.line]); return; }
      var n = parseInt(raw, 10);
      if (isNaN(n) || n < 1) return;
      desired[row.dataset.line] = n;
      schedule(row.dataset.line, 700);
    });

    cartRoot.addEventListener('blur', function (e) {
      var q = e.target.closest('[data-qty]');
      if (!q) return;
      var row = q.closest('[data-line]');
      var n = parseInt(q.value, 10);
      if (isNaN(n) || n < 1) {
        q.value = desired[row.dataset.line] || 1;
        return;
      }
      setQty(row, n, 0);
    }, true);

    cartRoot.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' && e.target.closest('[data-qty]')) {
        e.preventDefault();
        e.target.blur();
      }
    });
  }

  /* ---------------- single-open FAQ ---------------- */
  var faqDetails = document.querySelectorAll('.faq details');
  faqDetails.forEach(function (d) {
    d.addEventListener('toggle', function () {
      if (d.open) faqDetails.forEach(function (o) { if (o !== d) o.open = false; });
    });
  });
})();
